import React from 'react';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';
import { PasswordStrengthMeter } from '../Common';
import FormCell from '../FormStructure/FormCell';
import { PASSWORD_STRENGTH_FEATURE_FLAG_QUERY } from './ChangePasswordModalOperations';

const propTypes = {
  password: PropTypes.string.isRequired,
};

/**
 * Component that conditionally renders PasswordStrengthMeter based on feature flag
 */
export default function PasswordStrengthMeterWithFlag({ password }) {
  const { data } = useQuery(PASSWORD_STRENGTH_FEATURE_FLAG_QUERY, {
    ssr: false,
    context: { batch: true },
  });

  if (!data?.isPasswordStrengthEnabled) {
    return null;
  }

  return (
    <FormCell>
      <PasswordStrengthMeter password={password} />
    </FormCell>
  );
}

PasswordStrengthMeterWithFlag.propTypes = propTypes;
